import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'
import isCoreLanguage from './isCoreLanguage'

export default function useGetInvolvedLinks() {
  const { t } = useTranslation()
  const censusNavFlag = useFeatureFlag('home_header_fiftiesCensusNav')
  const updateIndexingLink = useFeatureFlag('home_whatIsIndexing').isOn

  const getInvolvedLinks = {
    id: 'get-involved',
    text: t('nav.get-involved', 'Get Involved'),
    sub: [
      { id: 'overview', text: t('nav.overview', 'Overview'), url: '/getinvolved/' },
      {
        id: 'my_opportunities',
        text: t('nav.get-involved.updated.opportunities', 'Opportunities'),
        url: '/getinvolved/my-opportunities',
      },
      { id: 'your-impact', text: t('nav.get-involved.your-impact', 'Your Impact'), url: '/getinvolved/your-impact' },
      {
        id: 'indexing',
        text: updateIndexingLink ? t('nav.what-is-indexing', 'What is Indexing?') : t('nav.indexing', 'Indexing'),
        url: updateIndexingLink ? `/${i18n.language}/indexing` : '/indexing/my-indexing',
      },
      {
        id: 'census',
        text: t('nav.get-involved.census', '1950 U.S. Census'),
        url: '/getinvolved/1950',
      },
    ],
  }

  getInvolvedLinks.sub = getInvolvedLinks.sub.filter((link) => {
    let keep = true

    if (link.id === 'census' && !(i18n.language === 'en' && censusNavFlag.isOn)) {
      keep = false
    }
    if (
      link.id === 'your-impact' &&
      !(isCoreLanguage(i18n.language) || ['cs', 'da', 'hu', 'no', 'ro', 'uk', 'sm'].includes(i18n.language))
    ) {
      keep = false
    }

    return keep
  })

  return getInvolvedLinks
}
